/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ArrowLeftRightLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M16.05 12.05 21 17l-4.95 4.95-1.41-1.41L17.17 18H4v-2h13.17l-2.53-2.54zm-8.1-10 1.41 1.41L6.83 6H20v2H6.83l2.53 2.54-1.41 1.4L3 7z" />
  </Icon>
);
